export const PREPARER_OPTIONS = {
  salesperson: 'salesperson',
  estimator: 'estimator',
  both: 'both',
} as const;

export const QUOTE_NOTES_PLACEMENT_OPTIONS = {
  above: 'above',
  below: 'below',
} as const;

export const QUOTE_TOTAL_DISPLAY_OPTIONS = {
  range: 'range',
  max: 'max',
} as const;
